import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./loginSlice";
import companyReducer from "./companySlice";

export const store = configureStore({
  reducer: { login: loginReducer ,companies: companyReducer,}
  
});
